export const ADD_POLL = "ADD_POLL"
export const ADD_POLL_SUCCESS = "ADD_POLL_SUCCESS"
export const ADD_POLL_FAILED = "ADD_POLL_FAILED"

export const GET_POLL = "GET_POLL"
export const GET_POLL_SUCCESS = "GET_POLL_SUCCESS"
export const GET_POLL_FAILED = "GET_POLL_FAILED"
export const RESET_POLL = "RESET_POLL"

export const UPDATE_POLL = "UPDATE_POLL"
export const UPDATE_POLL_SUCCESS = "UPDATE_POLL_SUCCESS"
export const UPDATE_POLL_FAILED = "UPDATE_POLL_FAILED"

export const GET_POLL_LIST = "GET_POLL_LIST"
export const GET_POLL_LIST_SUCCESS = "GET_POLL_LIST_SUCCESS"
export const GET_POLL_LIST_FAILED = "GET_POLL_LIST_FAILED"
export const RESET_POLL_LIST = "RESET_POLL_LIST"

export const DELETE_POLL = "DELETE_POLL"
export const DELETE_POLL_SUCCESS = "DELETE_POLL_SUCCESS"
export const DELETE_POLL_FAILED = "DELETE_POLL_FAILED"

export const OPEN_DELETE_POLL_MODAL = "OPEN_DELETE_POLL_MODAL"
export const HIDE_DELETE_POLL_MODAL = "HIDE_DELETE_POLL_MODAL"

export const UPDATE_POLL_LIST_ITEM = "UPDATE_POLL_LIST_ITEM"
export const UPDATE_POLL_LIST_ITEM_SUCCESS = "UPDATE_POLL_LIST_ITEM_SUCCESS"
export const UPDATE_POLL_LIST_ITEM_FAILED = "UPDATE_POLL_LIST_ITEM_FAILED"

export const UPDATE_POLL_ORDER = "UPDATE_POLL_ORDER"
export const UPDATE_POLL_ORDER_SUCCESS = "UPDATE_POLL_ORDER_SUCCESS"
export const UPDATE_POLL_ORDER_FAILED = "UPDATE_POLL_ORDER_FAILED"

export const GET_POLL_REPLY = "GET_POLL_REPLY"
export const GET_POLL_REPLY_SUCCESS = "GET_POLL_REPLY_SUCCESS"
export const GET_POLL_REPLY_FAILED = "GET_POLL_REPLY_FAILED"
export const RESET_POLL_REPLY = "RESET_POLL_REPLY"
